import { Route, RouteProps } from 'react-router';
import * as React from 'react';
import { getToken } from '../Token/GetToken';

const AuthRoute: React.FunctionComponent<RouteProps> = ({ ...routeProps }) => {
  if (!getToken()) {
    window.location.replace('/login');
    return null;
  }

  return <Route {...routeProps} />;
};

export default AuthRoute;
